import React from "react";

const AdminPortal = () => {
  return <div>AdminPortal</div>;
};

export default AdminPortal;
